import type {Rec} from 'src/typings';
import {anyMatches, byIdOf, removeAll} from 'shared/utils/array-utils';
import type {Observable, Subject} from 'rxjs';
import {BehaviorSubject} from 'rxjs';

export class RecordClipboardService {
    public static serviceName = 'recordClipboardService';

    private records: Rec[] = [];
    private records$: Subject<Rec[]> = new BehaviorSubject([])

    public getRecords$(): Observable<Rec[]> {
        return this.records$.asObservable();
    }

    public add(item: Rec) {
        if (this.contains(item)) {
            return;
        }

        this.records.push(item);
        this.notify();
    }

    public remove(item: Rec) {
        if (!this.contains(item)) {
            return;
        }

        this.records = removeAll(this.records, byIdOf(item));
        this.notify();
    }

    public removeAll() {
        this.records = [];
        this.notify();
    }

    public isEmpty(): boolean {
        return this.records.length === 0;
    }

    public size(): number {
        return this.records.length;
    }

    public getAll(): Rec[] {
        return this.records;
    }

    public contains(record: Rec): boolean {
        return anyMatches(this.records, byIdOf(record));
    }

    private notify() {
        this.records$.next(this.records);
    }
}